<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.5 2.25C3.25736 2.25 2.25 3.25736 2.25 4.5V6.5C2.25 7.74264 3.25736 8.75 4.5 8.75H6.5C7.74264 8.75 8.75 7.74264 8.75 6.5V4.5C8.75 3.25736 7.74264 2.25 6.5 2.25H4.5ZM3.75 4.5C3.75 4.08579 4.08579 3.75 4.5 3.75H6.5C6.91421 3.75 7.25 4.08579 7.25 4.5V6.5C7.25 6.91421 6.91421 7.25 6.5 7.25H4.5C4.08579 7.25 3.75 6.91421 3.75 6.5V4.5Z"
            fill="currentColor"
        />
        <path d="M13 11H16.5V12.5H13V11Z" fill="currentColor" />
        <path d="M13 16H11V12.5H13V16Z" fill="currentColor" />
        <path d="M15 16V18H13V16H15Z" fill="currentColor" />
        <path d="M16.5 14H15V16H16.5V18H18V16H16.5V14Z" fill="currentColor" />
        <path d="M16.5 14H18V12.5H16.5V14Z" fill="currentColor" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.25 4.5C11.25 3.25736 12.2574 2.25 13.5 2.25H15.5C16.7426 2.25 17.75 3.25736 17.75 4.5V6.5C17.75 7.74264 16.7426 8.75 15.5 8.75H13.5C12.2574 8.75 11.25 7.74264 11.25 6.5V4.5ZM13.5 3.75C13.0858 3.75 12.75 4.08579 12.75 4.5V6.5C12.75 6.91421 13.0858 7.25 13.5 7.25H15.5C15.9142 7.25 16.25 6.91421 16.25 6.5V4.5C16.25 4.08579 15.9142 3.75 15.5 3.75H13.5Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.5 11.25C3.25736 11.25 2.25 12.2574 2.25 13.5V15.5C2.25 16.7426 3.25736 17.75 4.5 17.75H6.5C7.74264 17.75 8.75 16.7426 8.75 15.5V13.5C8.75 12.2574 7.74264 11.25 6.5 11.25H4.5ZM3.75 13.5C3.75 13.0858 4.08579 12.75 4.5 12.75H6.5C6.91421 12.75 7.25 13.0858 7.25 13.5V15.5C7.25 15.9142 6.91421 16.25 6.5 16.25H4.5C4.08579 16.25 3.75 15.9142 3.75 15.5V13.5Z"
            fill="currentColor"
        />
    </svg>
</template>
